export function formatArs(amount: number): string {
  return `$${amount.toLocaleString('es-AR')}`
}

export function pad(value: number): string {
  return value.toString().padStart(2, '0')
}
